<template>
  <div class="points-card">
    <div>
      <div class="info">
        <div class="info__header">
          <h1>Movimento de Pontos</h1>
        </div>
        <div class="info__item">
          <p>Saldo de Início</p>
          <p>{{ points.initial || 0 | point }}</p>
        </div>
        <div class="info__item">
          <p>Entrada de Pontos</p>
          <div class="tooltip1">
            <p>{{ points.credits || 0}}</p>
            <span class="tooltiptext">Vendas: {{ points.sales_total || 0 | point}} <br> Treinamentos: {{ points.trainings || 0 | point }}</span>
          </div>
        </div>
        <div class="info__item">
          <p>Resgate de Pontos</p>
          <p>{{ -points.redemptions || 0 | point }}</p>
        </div>
        <div class="info__item">
          <p>Saldo Final</p>
          <p>{{ points.total || 0 | point }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'points-card',
  computed: mapState({
    points: (state) => state.dashboard.points,
  }),
};
</script>

<style lang="scss" scoped>

.tooltip1 {
  position: relative;
  display: inline-block;
}

.tooltip1 .tooltiptext {
  visibility: hidden;
  width: 200px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 6px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
}

.tooltip1:hover .tooltiptext {
  visibility: visible;
}

.points-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 12px 0px;
  padding-right: 0px;
  box-shadow: 0px 2px 10px rgba(21, 23, 64, 0.03);

  > div {
    display: flex;

    .info {
      flex: 1;
      margin-right: 0px;

      p{
        padding-left: 30px;
        padding-right: 60px;
      }
    }

    .chart {
      width: 160px;
      min-height: 160px;
    }
  }

  .info {
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      h1 {
        padding-left: 30px;
        font-size: 1.2rem;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.registered > p:last-child::after {
        background: var(--color-success);
      }

      &.not-registered > p:last-child::after {
        background: var(--color-danger);
      }

      &:not(:last-child) {
        padding-bottom: 8px;
        border-top: 1px solid #dddeea;
      }

      &:last-child {
        padding-top: 8px;
        border-top: 1px solid #dddeea;
      }

      p:last-child {
        color: var(--text-color-light);
        position: relative;

        &::after {
          content: '';
          border-radius: 50%;
          width: 6px;
          height: 6px;
          position: absolute;
          top: 0;
          right: -5px;
        }
      }
    }
  }
}


</style>
